import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "var(--color-black)",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M10.293.893a1 1 0 0 1 1.414 0l2 2a1 1 0 0 1 0 1.414l-2 2a1 1 0 1 1-1.414-1.414l.252-.252a7.503 7.503 0 0 0-2.956 13.426 1 1 0 1 1-1.178 1.616A9.49 9.49 0 0 1 2.5 12c0-4.767 3.512-8.715 8.09-9.396l-.297-.297a1 1 0 0 1 0-1.414m5.899 3.644a1 1 0 0 1 1.397-.22A9.49 9.49 0 0 1 21.499 12c0 4.768-3.51 8.715-8.089 9.396l.297.297a1 1 0 0 1-1.414 1.414l-2-2a1 1 0 0 1 0-1.414l2-2a1 1 0 1 1 1.414 1.414l-.252.252a7.502 7.502 0 0 0 2.956-13.425 1 1 0 0 1-.22-1.397" }, null, -1)
  ]))]))
}
export default { render: render }